import { render, staticRenderFns } from "./ChooseUser.vue?vue&type=template&id=4bef63d4&scoped=true"
import script from "./ChooseUser.vue?vue&type=script&lang=js"
export * from "./ChooseUser.vue?vue&type=script&lang=js"
import style0 from "./ChooseUser.vue?vue&type=style&index=0&id=4bef63d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bef63d4",
  null
  
)

export default component.exports